import {Injectable, inject } from "@angular/core";
import { AppSettingsService } from "../../core";
import { IJustificationModel } from "./justification-dialog.model";
import { Observable, shareReplay } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn:"any"
})
export class JustificationDialogService{
    
    private httpClient = inject(HttpClient);
    private appSettingsService = inject(AppSettingsService);

    private readonly baseurl:string = `${this.appSettingsService.baseApiUrl}/api/MasterData`;

    public GetJustificationMasterData():Observable<IJustificationModel[]>{
        let url:string = `${this.baseurl}/get-master-justifications`;
        return this.httpClient.get<IJustificationModel[]>(url).pipe(shareReplay());
    }
    
}